import { Stack, Text } from "@mantine/core";
import { useCallback } from "react";
import type { AddendumCodeOption } from "../../services/addendum.service";
import { AddendumCptQuantityInput } from "./AddendumCptQuantityInput";
import type { AdditionalCptCodeQuantities } from "./addendumCptQuantities";
import { isValidAdditionalCptQuantity } from "./addendumCptQuantities";

interface AddendumCptQuantityRowsProps {
  selectedIds: string[];
  options: AddendumCodeOption[];
  quantities: AdditionalCptCodeQuantities;
  disabled: boolean;
  validationRequested: boolean;
  onChange: (codeId: string, value: number | string) => void;
  onBlur: () => void;
}

export function AddendumCptQuantityRows({
  selectedIds,
  options,
  quantities,
  disabled,
  validationRequested,
  onChange,
  onBlur,
}: AddendumCptQuantityRowsProps) {
  const labelFor = useCallback(
    (id: string) => {
      const option = options.find((candidate) => candidate.id === id);
      return option ? `${option.code} quantity` : "CPT quantity";
    },
    [options]
  );

  if (selectedIds.length === 0) return null;

  return (
    <Stack gap="xs" aria-label="Additional CPT quantities">
      <Text size="sm" fw={500}>
        Quantities
      </Text>
      {selectedIds.map((id) => (
        <AddendumCptQuantityInput
          key={id}
          codeId={id}
          label={labelFor(id)}
          value={quantities[id] ?? 1}
          error={
            validationRequested &&
            !isValidAdditionalCptQuantity(quantities[id] ?? 1)
              ? "Enter a whole number from 1 to 99"
              : undefined
          }
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
        />
      ))}
    </Stack>
  );
}
